import { StandaloneProseProps } from '@/components/element/Prose';
import c from '@/styles/ContentRichtextbox';
import { ClassNameProp, Component } from '@/types/component';
import deepmerge from 'deepmerge';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';
import { standaloneComponent } from 'modules/dynamic-components';

const Prose = standaloneComponent<StandaloneProseProps>('ElementProse');

export interface RichtextboxProps extends StandaloneProseProps {
  variant?: ClassNameProp;
  colors?: ClassNameProp;
  size?: ClassNameProp;
}

// TODO: fix this after refactoring `Richtextbox`
// @ts-expect-error
const RichtextboxComponent: Component<RichtextboxProps> = ({ children, variant, colors, size, options, ...props }) => {
  const getPropStyles = getPropStylesFactory(c);
  const { className, ...baseOptions } = options ?? {};

  const sizeClassName = getPropStyles('size', size ?? variant);
  const colorsClassName = getPropStyles('colors', colors ?? variant);
  const variantClassName = getPropStyles('variant', variant);

  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  const overrideProse = (componentClassName as string)?.includes('prose');

  return (
    <Prose
      options={deepmerge(baseOptions, {
        size: overrideProse ? 'none' : undefined,
        className: componentClassName,
      })}
      {...props}
    />
  );
};

export const Richtextbox = RichtextboxComponent;
